import { render, staticRenderFns } from "./StockItem.vue?vue&type=template&id=4e0b62ba&scoped=true&"
import script from "./StockItem.vue?vue&type=script&lang=js&"
export * from "./StockItem.vue?vue&type=script&lang=js&"
import style0 from "./StockItem.vue?vue&type=style&index=0&id=4e0b62ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b62ba",
  null
  
)

export default component.exports